import { useEffect, useState } from 'react';
import { useShipmentsService } from '../contexts/shipments-service';
import { GetShipmentsQuery, Shipment, ShipmentsService } from '../ports/ShipmentsService';

export function createUseShipments(
  {
    useShipmentsService,
  }: {
    useShipmentsService: () => ShipmentsService | undefined;
  },
) {
  return function useShipments(query?: GetShipmentsQuery) {
    const shipmentsService = useShipmentsService();

    const [shipments, setShipments] = useState<Shipment[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();
    const [page, setPage] = useState<number>(1);
    const [pages, setPages] = useState<number>(1);

    useEffect(
      () => {
        if (!shipmentsService || !query) {
          return;
        }

        setIsLoading(true);
        shipmentsService.getShipments(query)
          .then(({ shipments, page, count, limit }) => {
            setShipments(shipments);
            setIsLoading(false);
            setPage(page);
            setPages(Math.ceil(count / limit));
          })
          .catch(setError);
      },
      [shipmentsService, query],
    );

    return {
      shipments,
      isLoading,
      page,
      pages,
      error,
    };
  };
}

export const useShipments = createUseShipments({ useShipmentsService });
